import { View } from '@react-pdf/renderer';
import React from "react";
import { Dashboard, DashboardQuery } from "../../../types/files";
import PDFDashboardQueries from './PDFDashboardQueries';
import styles from "./styles";
import PDFDashboardDetails from './PDFDashboardDetails';

const PDFBody: React.FC<{ dashboard: Dashboard|null, queries: DashboardQuery[] }> = ({ dashboard, queries }) => {
    return (<>
        <View style={styles.body}>
            <PDFDashboardDetails dashboard={dashboard} queries={queries} />
            <View style={{...styles.topDivider, marginTop: 8, marginBottom: 8 }} />
            <PDFDashboardQueries queries={queries} />
        </View>
    </>);
}

export default PDFBody;